import styled from 'styled-components';
import { Box, Text } from '@rsos/components/capstone/base';
import { BP_LAPTOP } from '@rsos/constants/breakpoints';
import { QUEUE_FULL_WIDTH } from '@rsos/constants/queueWidths';
import { RemoveCall } from '../EmergencyCall/EmergencyCall.styles';

const airAmbulanceBg = (isHovered, isSelected) => {
  let backgroundColor = 'background';

  if (isHovered) backgroundColor = 'foreground';
  else if (isSelected) backgroundColor = 'highlights';

  return backgroundColor;
};

export const Container = styled(Box).attrs(
  ({ isExpired, isHovered, isSelected }) => ({
    horizontal: true,
    align: 'center',
    justify: 'space-between',
    position: 'relative',
    width: '100%',
    minHeight: 70,
    backgroundColor: airAmbulanceBg(isHovered, isSelected),
    padding: '8px 24px 8px 22px',
    cursor: 'pointer',
    opacity: isExpired ? 0.4 : 1,
  }),
)`
  border-bottom: 1px solid ${({ theme }) => theme.colors.lightLineDivider};
  font-family: 'Roboto', sans-serif;
  user-select: none;
  &:hover {
    background-color: ${({ theme, isSelected }) =>
      !isSelected && theme.colors.foreground};
  }
  @media (max-width: ${BP_LAPTOP}px) {
    width: ${QUEUE_FULL_WIDTH};
  }
`;

export const IconBox = styled(Box).attrs({
  flex: '0 0 auto',
  marginRight: 22,
  color: 'secondaryText',
})``;

export const AirAmbulanceQueueBox = styled(Box).attrs({
  flex: '1 1 auto',
  overflow: 'hidden',
})``;

export const AirAmbulanceTitle = styled(Text).attrs({
  color: 'primaryText',
  size: 'large',
  fontWeight: 'bold',
})``;

export const SecondarDetails = styled(Text).attrs({
  marginTop: '4px',
  color: 'secondaryText',
  size: 'small',
  textTransform: 'uppercase',
})``;

export const TimeBox = styled(Box).attrs({
  flex: '0 0 auto',
  marginLeft: '10px',
  overflow: 'hidden',
})``;

export const Time = styled(Text).attrs({
  color: 'secondaryText',
  size: 'xsmall',
  textAlign: 'right',
})``;

export const RemoveAirAmbulance = styled(RemoveCall)``;
